import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  VideoCarouselComponent,
  videoData,
} from '../../../shared/components/video-carousel/video-carousel.component';

@Component({
  selector: '[video-section]',
  imports: [VideoCarouselComponent],
  templateUrl: './video-section.html',
  styleUrl: './video-section.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoSection {
  videoData: videoData[] = [
    {
      videoThumbnail: '',
      thumbnailAltText:
        'A silhouette of Usher wearing sunglasses and holding his right hand up',
      videoSrc: 'https://www.youtube.com/embed/QC_XlUj_bAc?si=GNrWsA8a6b7OGbQr',
      playing: false,
      transcriptText: `
        <span class="fw-bold">Adam Schefter:</span><br />You may have noticed I've been talking a lot about the importance of screening for type 1 diabetes. This is personal for me and my family. My wife has T1D, and I've seen what she and so many other diabetes warriors have to navigate every day. And what I've learned is that while knowing sooner doesn't change the outcome, it can give you time to plan, prepare, get educated, and take action. That's why I've been so proud to partner with Sanofi to get the word out about screening. And the good news? You can start learning about your risk for type 1 diabetes with an at-home screening test kit.<br /><br />
        Each kit comes with an alcohol pad, a lancet for drawing blood, and a blood spot card. Step one is you're going to have to clean your finger, then twist off the cap and push the lancet into your finger, and put the blood spots on the sample card here. It's important to put enough blood on the sample card for the lab to get a reading. Now you just let it dry, package it up, and send it to the lab, and you should have your results in a few weeks. You can use the time before insulin dependence to educate yourself and your family, build a care team, and get connected to the T1D community.<br /><br />
        So talk to your doctor today to make a screening plan, because the more you know, the more confident you can be in making the best choices possible for you and your loved ones.
      `,
    },
  ];
}
